import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/functions'
import * as ENV from '../../settings'

let config = {
    apiKey: ENV.FIREBASE_API_KEY,
    authDomain: ENV.FIREBASE_AUTH_DOMAIN,
    databaseURL: ENV.FIREBASE_DATABASE_URL,
    projectId: ENV.FIREBASE_PROJECT_ID,
    storageBucket: ENV.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: ENV.FIREBASE_MESSAGING_SENDER_ID
}

firebase.initializeApp(config)

const db = firebase.database()
const functions = firebase.functions()
// const storage = firebase.storage()
const auth = firebase.auth()

// ============================ NODES ==============================

// -- COURIER PROVIDER NODE --
const couriersNode = db.ref('couriers')

// -- ORDERS NODE --
const ordersNode = db.ref('orders')
const orderTransactionsNode = db.ref('orderTransactions')
const orderMessagesNode = db.ref('orderMessages')
const relGlobalOrdersPaymentStatusNode = db.ref('rel_global_orders_by_paymentStatus')

// -- PRODUCTS NODE --
const productsNode = db.ref('products')

// -- STORES NODE --
const storeProfilesNode = db.ref('storeProfiles')
const storesNode = db.ref('stores')

// -- USERS NODE --
const usersNode = db.ref('users')
const userAddressesNode = db.ref('userAddresses')
const userOrdersNode = db.ref('rel_users_orders')

// -- USERS STORE NODE --
const usersStoreNode = db.ref('usersStore')

// -- USERS SUPPORT NODE --
const usersSupportNode = db.ref('usersSupport')

export {
    db,
    functions,
    auth,
    usersSupportNode,
    usersNode,
    usersStoreNode,
    userAddressesNode,
    userOrdersNode,
    ordersNode,
    orderTransactionsNode,
    orderMessagesNode,
    storesNode,
    storeProfilesNode,
    productsNode,
    couriersNode,
    relGlobalOrdersPaymentStatusNode
}
